import { func_validation } from 'functions';
import React, { useEffect, useRef, useState } from 'react';

export function useDropdownList(props) {
    const {
        allAdvancePaySetupList,
        getAllAdvancePaySetupList_requesting,
        isAccountRecordUpdatedSuccessfully,
    } = props;

    const [comIdList, setComIdList] = useState([]);
    const [accountCodeList, setAccountCodeList] = useState([]);
    const [productCodeList, setProductCodeList] = useState([]);
    const [dealerCodeList, setDealerCodeList] = useState([]);
    const [salesPersonCodeList, setSalesPersonCodeList] = useState([]);
    const [productNameList, setProductNameList] = useState([]);

    let filter = useRef({});
    const [isRenderRequired, setIsRenderRequired] = useState();

    // Get Data
    function getAllAdvancePaySetup() {
        if (func_validation.isFunction(props.getAllAdvancePaySetupList) &&
            (func_validation.isNullUndefined(isAccountRecordUpdatedSuccessfully) ||
                func_validation.isBooleanTrueNotNullUndefined(isAccountRecordUpdatedSuccessfully))) 
                
            props.getAllAdvancePaySetupList(null, null, null, filter.current);
    }
    useEffect(() => {
        getAllAdvancePaySetup();
    }, [
        isAccountRecordUpdatedSuccessfully, isRenderRequired
    ]);

    function setDropdownLists() {
        if (func_validation.isArray(allAdvancePaySetupList) &&
            func_validation.isBooleanFalseNotNullUndefined(getAllAdvancePaySetupList_requesting)) {

            let comIdList_new = [];
            let accountCodeList_new = [];
            let productCodeList_new = [];
            let dealerCodeList_new = [];
            let salesPersonCodeList_new = [];
            let productNameList_new = [];

            // Used to check duplicates in O(1) time
            let referenceObj_comId = {}; 
            let referenceObj_accountCode = {}; 
            let referenceObj_productCode = {}; 
            let referenceObj_dealerCode = {}; 
            let referenceObj_salesPersonCode = {}; 
            let referenceObj_productName = {}; 

            // Get lists
            for (let i = 0; i < allAdvancePaySetupList.length; i++) {
                let companyId = func_validation.getObjectPropertyValueNotNullUndefined(allAdvancePaySetupList[i], "CompanyId", "");
                let accountCode = func_validation.getObjectPropertyValueNotNullUndefined(allAdvancePaySetupList[i], "AccountCode", "");
                let productCode = func_validation.getObjectPropertyValueNotNullUndefined(allAdvancePaySetupList[i], "ProductCode", "");
                let dealerCode = func_validation.getObjectPropertyValueNotNullUndefined(allAdvancePaySetupList[i], "DealerCode", "");
                let salesPersonCode = func_validation.getObjectPropertyValueNotNullUndefined(allAdvancePaySetupList[i], "SalesPersonCode", "");
                let productName = func_validation.getObjectPropertyValueNotNullUndefined(allAdvancePaySetupList[i], "ProductName", "");

                let isCompanyIdFound = func_validation.getObjectPropertyValue(referenceObj_comId, companyId + "");
                let isAccountCodeFound = func_validation.getObjectPropertyValue(referenceObj_accountCode, accountCode + "");
                let isProductCodeFound = func_validation.getObjectPropertyValue(referenceObj_productCode, productCode + "");
                let isDealerCodeFound = func_validation.getObjectPropertyValue(referenceObj_dealerCode, dealerCode + "");
                let isSalesPersonCodeFound = func_validation.getObjectPropertyValue(referenceObj_salesPersonCode, salesPersonCode + "");
                let isProductNameFound = func_validation.getObjectPropertyValue(referenceObj_productName, productName + "");

                // Add to list
                if (!isCompanyIdFound &&
                    func_validation.isNumberValid(companyId)) {
                    referenceObj_comId[companyId] = true;
                    comIdList_new.push(companyId);
                }
                if (!isAccountCodeFound &&
                    func_validation.isStringTrimNotEmpty(accountCode)) {
                    referenceObj_accountCode[accountCode] = true;
                    accountCodeList_new.push(accountCode);
                }
                if (!isProductCodeFound &&
                    func_validation.isStringTrimNotEmpty(productCode)) {
                    referenceObj_productCode[productCode] = true;
                    productCodeList_new.push(productCode);
                }
                if (!isDealerCodeFound &&
                    func_validation.isStringTrimNotEmpty(dealerCode)) {
                    referenceObj_dealerCode[dealerCode] = true;
                    dealerCodeList_new.push(dealerCode);
                }
                if (!isSalesPersonCodeFound &&
                    func_validation.isStringTrimNotEmpty(salesPersonCode)) {
                    referenceObj_salesPersonCode[salesPersonCode] = true;
                    salesPersonCodeList_new.push(salesPersonCode);
                }
                if (!isProductNameFound &&
                    func_validation.isStringTrimNotEmpty(productName)) {
                    referenceObj_productName[productName] = true;
                    productNameList_new.push(productName);
                }
            }


            // Update List States

            let comIdListSorted_new = comIdList_new.sort();
            let comIdList_dropdown = func_validation.convertArrayToDropdownArrayFormat(comIdListSorted_new);
            setComIdList(comIdList_dropdown);

            let accountCodeListSorted_new = accountCodeList_new.sort();
            let accountCodeList_dropdown = func_validation.convertArrayToDropdownArrayFormat(accountCodeListSorted_new);
            setAccountCodeList(accountCodeList_dropdown);

            let productCodeListSorted_new = productCodeList_new.sort();
            let productCodeList_dropdown = func_validation.convertArrayToDropdownArrayFormat(productCodeListSorted_new);
            setProductCodeList(productCodeList_dropdown);

            let dealerCodeListSorted_new = dealerCodeList_new.sort();
            let dealerCodeList_dropdown = func_validation.convertArrayToDropdownArrayFormat(dealerCodeListSorted_new);
            setDealerCodeList(dealerCodeList_dropdown);

            let salesPersonCodeListSorted_new = salesPersonCodeList_new.sort();
            let salesPersonCodeList_dropdown = func_validation.convertArrayToDropdownArrayFormat(salesPersonCodeListSorted_new);
            setSalesPersonCodeList(salesPersonCodeList_dropdown);

            let productNameListSorted_new = productNameList_new.sort();
            let productNameList_dropdown = func_validation.convertArrayToDropdownArrayFormat(productNameListSorted_new);
            setProductNameList(productNameList_dropdown);            
        }
    }
    useEffect(() => {
        setDropdownLists();
    }, [JSON.stringify(allAdvancePaySetupList)]);

    return {
        comIdList,
        accountCodeList,
        productCodeList,
        dealerCodeList,
        salesPersonCodeList,
        productNameList,

        filter, setIsRenderRequired, isRenderRequired
    }
}